import React, { useContext, useState, useRef } from 'react';
import { adminUserPut } from '../../api';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/User';
import { somethingWentWrongNotice } from '../UI/Notifications';
import { SearchContext } from '../../context/Search';
import { LayersControl } from 'react-leaflet';

const DisableUser = ({ id, status }) => {
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const { setSearchTrigger, searchTrigger } = useContext(SearchContext);
  const history = useHistory();

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push("/");
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout();
    } else {
      somethingWentWrongNotice("Disable User");
    }
  }

  const disableUser = (e) => {
    adminUserPut({is_active: !status}, {user_id: id})
    .then(() => {
      setSearchTrigger(!searchTrigger);
    })
    .catch(error => handleDefaultStatusCodes(error.response.status));
  }

  return (
    <div
      onClick={(e) => disableUser(e)}
      className="Dropdown_Item"
    >
        <span className="ml-2">{`${status ? "Disable" : "Enable"} User`}</span>
    </div>
  )
}

export default DisableUser;
